/**
 * City-specific navigation menu configurations for Cabo.
 * Defines desktop nav items (label + href).
 * DashboardNavbar resolves the active config based on the current route.
 */

const CABO_NAV = [
  { href: '/los-cabos-mexico-event-calendar', label: 'CALENDAR' },
  { href: '/los-cabos-clubs', label: 'CLUBS' },
  { href: '/los-cabos-events-today', label: 'TODAY' },
  { href: '/los-cabos-dinner-table-reservations', label: 'DINNER' },
  { href: '/los-cabos-nightlife', label: 'NIGHTLIFE' },
];

/**
 * Returns the nav items for the given route path.
 */
export function getNavItemsForRoute() {
  return CABO_NAV;
}

export { CABO_NAV };
